import { DateRangeValue } from '@hub-components'
import { MenuItem } from 'primeng/api'

export const DEFAULT_TITLE_FONT_SIZE = 18

export const DEFAULT_TITLE_ALIGNMENT = 'center'

export const DEFAULT_LEGEND_FONT_SIZE = 14

export const DEFAULT_AXIS_FONT_SIZE = 12

export const DEFAULT_AXIS = 'left'

export const DEFAULT_TABLE_TEXT_FONT_SIZE = 14

export const DEFAULT_DATA_LABEL_FONT_SIZE = 14

export const DEFAULT_KPI_METRIC = {align: 'center', size: 56}

export const DEFAULT_DIMENSION_VALUE = {align: 'center', size: 56}

export const DEFAULT_METRIC_LABEL = { enabled: true, align: 'center', size: 22 }

export const DEFAULT_DIMENSION_LABEL = { enabled: true, align: 'center', size: 22 }

export const DEFAULT_RESULTS_PER_PAGE = 10

export const DEFAULT_DIMENSION_VALUE_RESULTS = 1

export const DEFAULT_FOOTER_TOGGLE = { datasetInfo: false, dateRange: false }

export const DEFAULT_INCLUDE_DIMENSIONS_TOGGLE = true

export const DEFAULT_SHOW_COLUMN_GRAND_TOTALS = false

export const DEFAULT_SHOW_ROW_GRAND_TOTALS = false

export const DEFAULT_DATE_RANGE = {
  enabled: false,
  value: <DateRangeValue> {
    type: 'dynamic' as 'dynamic',
    dynamic: {title: 'Last 7 Days', name: 'last', num: 7, unit: 'day' as 'day'},
  }
}

export const DEFAULT_MAP_TYPE = {value: 'custom/world-robinson', name: 'World'}

export const DEFAULT_COMPARE_TO = {name: 'None', value: 'none'}

export const UPLOAD_IMAGE = 'uploadImage';

export const INSERT_URL = 'insertUrl';

export const USE_ATTRIBUTE = 'useAttribute';

export const DEFAULT_IMAGE_SOURCE = UPLOAD_IMAGE;

export const DEFAULT_WYSIWYG_OPTIONS = {
  type: 'freetext',
  options: {
    globalDateRange: false,
  }
};

export const DEFAULT_WYSIWYG_PLACEMENT = { position: 'top' };

export const DEFAULT_WYSIWYG_TOOLBAR = true;

export const TAB_MENU_ITEMS: MenuItem[] = [
  {
    id: 'all',
    label: 'All dashboards',
    routerLink: '/all-dashboards',
  },
  {
    id: 'my',
    label: 'My dashboards',
    routerLink: '/my-dashboards',
  },
  {
    id: 'scheduled',
    label: 'Scheduled dashboards',
    routerLink: '/scheduled-dashboards',
  },
  {
    id: 'shared',
    label: 'Shared dashboards',
    routerLink: '/shared-dashboards',
  },
  {
    id: 'sharedWithMe',
    label: 'Shared with me',
    routerLink: '/shared-with-me',
  },
  {
    id: 'templates',
    label: 'Dashboard templates',
    routerLink: '/dashboard-templates',
  },
  {
    id: 'audits',
    label: 'Audits',
    routerLink: '/dashboard-audit-list',
  },
];
